import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["title", "disabled"]
const _hoisted_2 = ["alt", "src"]


export default /*@__PURE__*/_defineComponent({
  __name: 'button',
  props: {
    disabled: {
      default: false,
      required: false,
      type: Boolean,
    },
    image: {
      default: null,
      required: false,
      type: String
    },
    title: {
      default: null,
      required: true,
      type: String
    }
  },
  setup(__props) {

  

return (_ctx: any,_cache: any) => {
  const _component_scoped = _resolveComponent("scoped")!

  return (_openBlock(), _createBlock(_component_scoped, null, {
    default: _withCtx(() => [
      _createElementVNode("button", {
        title: __props.title,
        disabled: __props.disabled
      }, [
        (__props.image)
          ? (_openBlock(), _createElementBlock("img", {
              key: 0,
              alt: __props.title,
              src: __props.image
            }, null, 8, _hoisted_2))
          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _createTextVNode(_toDisplayString(__props.title), 1)
            ], 64))
      ], 8, _hoisted_1)
    ]),
    _: 1
  }))
}
}

})